<template>
  <div ref="watch"/>
</template>

<style scoped lang="scss">
.AScrollIntoViewport {
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AScrollIntoViewport extends Vue {
  $refs!: {
    watch: HTMLElement
  };

  created () {
    document.addEventListener('scroll', this.isInViewportCheck, {
      passive: true
    });
  }

  mounted () {
    this.isInViewportCheck();
  }

  beforeDestroy () {
    document.removeEventListener('scroll', this.isInViewportCheck);
  }

  isInViewportCheck () {
    // @ts-ignore
    const rect = this.$refs.watch.getBoundingClientRect();
    if (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    ) {
      console.log('in-viewport');
      this.$emit('in-viewport');
    }
  }
}
</script>
